var BlogPage = BlogPage || {};
  
  BlogPage = {
    init: function () {
      this.initInfiniteScroll();
      connsole.log("Test js from blog");
    },
    initInfiniteScroll: () => {
      // Load more
      function ScrollExecute() {
        if ($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
          scrollNode = $('#AjaxinatePagination').last();
  
          scrollURL = $('#AjaxinatePagination a').last().attr("href");
          if (scrollNode.length > 0 && scrollNode.css('display') != 'none') {
            $.ajax({
              type: 'GET',
              url: scrollURL,
              beforeSend: function () {
                scrollNode.clone().empty().insertAfter(scrollNode).append(`
                  <div class="loading_spinner">
                      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                      </svg>
                  </div>
                  `);
                scrollNode.hide();
              },
              success: function (data) {
                // remove loading feedback
                scrollNode.next().remove();
                var filteredData = $(data).find(".blog-list__item");
                var checkLastPage = $('#AjaxinatePagination a').last();
                var nextUrl = $(data).find('#AjaxinatePagination a').last().attr("href");
                // Change next page URL to current page of infinite scroll
                // If last page, remove link
                if (nextUrl) {
                  $('#AjaxinatePagination a').last().attr('href', nextUrl);
                  scrollNode.show();
                } else {
                  scrollNode.hide();
                }
                console.log('is last page?', checkLastPage);
                if (checkLastPage.length > 0) {
                  filteredData.appendTo($(".blog-list__wrap"));
                }
              },
              dataType: "html"
            });
          }
        }
      }
      (function () {
        $(window).scroll(function () {
          setTimeout(function () {
            ScrollExecute();
          }, 300);
        });
      })();
    },
  
  }
  
  $(function () {
      BlogPage.init();
  })
